export const BundleTreeTypes = {
  PROVIDER: 'provider',
  CATEGORY: 'category',
  SUB_CATEGORY: 'sub_category',
  CLUSTER: 'cluster',
  DOCUMENT: 'document',
} as const;

export type BundleTreeType = (typeof BundleTreeTypes)[keyof typeof BundleTreeTypes];

export interface SectionsTreeNode {
  id: string;
  name: string;
  numberOfPages: number;
  numberOfUnfilteredPages: number;
  pageIds?: string[];
  type: BundleTreeType;
  date?: string;
  shortTitle?: string;
  children?: SectionsTreeNode[];
}
